import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "@/assets/talentickaiwhite.webp";
import logo2 from "@/assets/talentick.ai.webp";
import authPhoto from "@/assets/auth.webp";
import api from "../components/customAxios/Axios";
import { useToast } from "../components/toast";
import GoogleAuth from "@/components/GoogleAuth";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import IsTokenValid from "@/api/IsTokenValid";
const Login: React.FC = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      setLoading(true);
      const valid = await IsTokenValid();
      if (valid) {
        navigate("/home");
      }
      setLoading(false);
    };
    checkAuth();
  }, []);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setLoading(true);

    try {
      const res = await api.post("/login", {
        email,
        password,
      });

      if (res.status === 200) {
        const {
          token,
          user_id,
          first_name,
          last_name,
          role,
          email,

          company_id,
          is_company_admin,
        } = res.data;

        localStorage.clear();
        localStorage.setItem("authToken", token);
        localStorage.setItem("user", user_id);
        localStorage.setItem("firstName", first_name);
        localStorage.setItem("lastName", last_name);
        localStorage.setItem("email", email);

        localStorage.setItem("role", role);
        localStorage.setItem("companyId", company_id);
        localStorage.setItem("isCompanyAdmin", is_company_admin);

        navigate("/home");

        window.location.reload();
      } else {
        toast.error({
          type: "background",
          duration: 5000,
          status: "error",
          title: "Login Failed",
          description: res.data?.error || res.data?.message || "Invalid credentials. Please try again.",
          open: true,
        });
      }
    } catch (err: any) {
      const error = err.response?.data?.error || err.response?.data?.message || "An unexpected error occurred during login. Please try again.";
      toast.error({
        type: "background",
        duration: 5000,
        status: "error",
        title: "Login Error",
        description: error,
        open: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (

    <div className="mx-auto   flex flex-col md:flex-row items-center  gap-8  bg-white ">

      {/* Mobile Logo */}
      <div className="w-full block md:hidden mb-6">
        <Link to="/" className="flex gap-2 items-center fixed top-10">
          <svg width="20" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10.0154 0.733154L4.23065 6.51518C3.93728 6.79466 3.93728 7.23137 4.23065 7.51085L10.0155 13.2928"
              stroke="#7F7F7F"
              strokeMiterlimit="2.613"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <img src={logo2} className="h-5" alt="Logo" />
        </Link>
      </div>

      {/* Left Side - Image and Text */}
      <div className="relative w-[55%] h-screen hidden md:block">
        <img
          src={authPhoto}
          alt="Background"
          className=" w-full h-screen  object-cover  shadow-md"
        />
        <div className="absolute inset-0 opacity-40 h-screen  bg-[#32413D]"></div>

        {/* Logo */}
        <Link to="/">
          <img
            src={logo}
            className="absolute top-8 left-8 max-h-10 cursor-pointer z-50"
            alt="Logo"
          />
        </Link>

        {/* Centered Text Box */}
        <div className="absolute inset-0 flex flex-col items-center justify-center px-8">
          <div className="bg-white/30 backdrop-blur-[70px] rounded-lg p-8 md:p-10 w-full max-w-[650px] text-white">
            <h2 className="text-2xl lg:text-5xl font-bold mb-4">
              Smarter Hiring Made Simple
            </h2>
            <p className="text-sm md:text-lg font-light">
              Experience a new era of recruitment with talentick.ai, where AI simplifies hiring automatically generating assessments, scoring resumes, and helping you find the right candidates faster. Get started today!
            </p>
          </div>
        </div>

        {/* Bottom text */}
        <div className="absolute bottom-8 w-full text-center text-white text-sm lg:text-base font-light">
          Browse through resumes and find the right candidate
        </div>
      </div>

      {/* Right Side - Login Form */}
      <div className="w-full md:w-[40%] overflow-auto  md:px-0 px-4 ">
        <div className="flex flex-col items-center justify-center py-4 s">
          <div className="w-full">
            <h2 className="text-2xl md:text-3xl font-bold text-center text-zinc-800 mb-6">
              Welcome Back!
            </h2>

            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-zinc-700 mb-1">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full border border-gray-300 rounded-lg py-3 px-4 text-zinc-700 bg-transparent focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Enter your email"
                  required
                />
              </div>

              <div className="relative">
                <label className="block text-sm font-medium text-zinc-700 mb-1">
                  Password
                </label>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="w-full border border-gray-300 rounded-lg py-3 px-4 text-zinc-700 bg-transparent focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent pr-10"
                    placeholder="Enter your password"
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute inset-y-0 right-3 flex items-center text-zinc-500 hover:text-zinc-700"
                  >
                    {showPassword ? (
                      <AiOutlineEyeInvisible size={20} />
                    ) : (
                      <AiOutlineEye size={20} />
                    )}
                  </button>
                </div>
              </div>

              <div className="flex items-center justify-end">
                <Link
                  to="/forget-password"
                  className="text-blue-500 text-sm hover:text-blue-700 transition-colors"
                >
                  Forgot password?
                </Link>
              </div>

              <button
                type="submit"
                className="w-full bg-[#162D3A] text-white font-semibold py-3 px-4 rounded-lg hover:bg-[#0e1c24] transition-colors duration-200 flex items-center justify-center"
                disabled={loading}
              >
                {loading ? "Logging in..." : "Login"}
              </button>

              <div className="relative my-6"></div>

              <GoogleAuth />

              <p className="text-center text-sm text-zinc-600 mt-6">
                Don't have an account?{" "}
                <Link
                  to="/register"
                  className="text-blue-500 font-medium hover:text-blue-700 transition-colors"
                >
                  Sign up
                </Link>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>



  );
};

export default Login;
